import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import CustomBackend from './utils/customI18nBackend';
import {
  DEFAULT_LANGUAGE,
  SUPPORTED_LANGUAGES,
  resolveInitialLanguage,
} from './features/language/languageConfig';

// On the server there is no stored choice, so this is the build-time default and
// the first paint is always in that language. The client re-reads the stored
// value here on every full document load.
const initialLanguage =
  typeof window !== 'undefined' ? resolveInitialLanguage() : DEFAULT_LANGUAGE;

i18n
  .use(CustomBackend)
  .use(initReactI18next)
  .init({
    lng: initialLanguage,
    fallbackLng: DEFAULT_LANGUAGE,
    supportedLngs: [...SUPPORTED_LANGUAGES],
    debug: false,
    ns: ['translation'],
    defaultNS: 'translation',
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: true,
    },
  });

export default i18n;
